export enum HOST_CONTRACT_CASE {
  APPROVE_READY = '승인_대기',
  CANCEL = '취소',
  CHECKIN_READY = '결제완료_입주_확인_전',
  CHECKOUT_READY = '결제완료_입주_후_정산_전',
  CHECKOUT_READY_AFTER_HOST_PAY = '결제완료_정산_완료',
  REFUND = '결제취소_정산_전',
  REFUND_AFTER_HOST_PAY = '결제취소_정산_완료',
  EXTEND_APPROVE_READY = '연장_승인_대기',
  EXTEND_CANCEL = '연장_취소',
  EXTEND_CHECKIN_READY = '연장_결제완료_입주_확인_전',
  EXTEND_CHECKOUT_READY = '연장_결제완료_입주_후_정산_전',
  EXTEND_CHECKOUT_READY_AFTER_HOST_PAY = '연장_결제완료_정산_완료',
  EXTEND_REFUND = '연장_결제취소_정산_전',
  EXTEND_REFUND_AFTER_HOST_PAY = '연장_결제취소_정산_완료',
}
